import React, {useState, useEffect, useRef} from 'react';
import {
  DropDownContainer,
  DropDownHeader,
  DropDownListContainer,
  DropDownList,
  ListItem,
  DownArrow,
  SelectContainer,
} from './select.styles';
import useOnClickOutside from '@ibibo/use-outside-click';

export default function FormSelect({
  options,
  startIcon,
  endIcon,
  placeholderText,
  onChange,
  dropdownWidth,
  dropdownHeight,
  selectionType,
  value,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    value?.monthString ? value?.monthString : placeholderText,
  );
  const selectRef = useRef();

  const toggling = () => setIsOpen(!isOpen);

  const closeToggle = () => setIsOpen(false);

  const onOptionClicked = value => () => {
    setSelectedOption(value?.monthString || value);
    setIsOpen(false);
    onChange && onChange(value, selectionType);
  };

  useOnClickOutside(selectRef, closeToggle);

  useEffect(() => {
    setSelectedOption(value?.monthString || placeholderText);
  }, [value]);

  return (
    <div ref={selectRef}>
      <DropDownHeader width={dropdownWidth} height={dropdownHeight} onClick={toggling}>
        <SelectContainer isOpen={isOpen}>
          {startIcon && (
            <span className={`mr10`}>
              <img src={startIcon} width={23} />
            </span>
          )}
          <span>{selectedOption}</span>
          {endIcon && <DownArrow isOpen={isOpen} />}
        </SelectContainer>
        {isOpen && (
          <DropDownListContainer>
            <DropDownList>
              {options.map(option => (
                <ListItem
                  onClick={onOptionClicked(option)}
                  key={Math.random()}
                  active={selectedOption === option ? 'true' : 'false'}
                >
                  {option?.monthString || option}
                </ListItem>
              ))}
            </DropDownList>
          </DropDownListContainer>
        )}
      </DropDownHeader>
    </div>
  );
}
